import type {Tree} from "~/interfaces/Tree";

export class Taxonomy {

    id: number;
    name: string;
    description: string = "";
    parent: Taxonomy | null = null;
    children: Array<Taxonomy> = [];
    tree: Array<Tree> = [];

    static createFromObj(obj: any): Taxonomy {
        const taxonomy = new Taxonomy(obj.id, obj.name);
        taxonomy.description = obj.description;
        taxonomy.parent = obj.parent ? Taxonomy.createFromObj(obj.parent) : null;
        taxonomy.children = obj.children ? obj.children.map((el: any) => Taxonomy.createFromObj(el)) : [];
        taxonomy.tree = obj.tree;

        return taxonomy;
    }

    constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

    get link(): string {
        return `/catalog/${this.id}`;
    }

}